export default {
  "baseURL": "http://localhost:3000",
  "browserBaseURL": "http://localhost:3000",
  "timeoutDuration": 15
}